document.addEventListener('DOMContentLoaded', function() {
  const videos = document.querySelectorAll('.product-media video, .slideshow__media video');
  
  const observerOptions = {
    threshold: 0.5 // La vidéo démarre quand 50% est visible
  };
  
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.play();
      } else {
        entry.target.pause();
      }
    });
  }, observerOptions);
  
  videos.forEach(video => {
    observer.observe(video);
  });
});
